"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addPracticeButtonListeners = addPracticeButtonListeners;
const __1 = require("../../..");
const taskSetup_1 = require("../../taskSetup");
const audioHandler_1 = require("./audioHandler");
const taskStore_1 = require("../../../taskStore");
function enableBtns(btnElements) {
    btnElements.forEach((btn) => (btn.disabled = false));
}
function addPracticeButtonListeners(answer, isTouchScreen, choices, onCorrect, onIncorrect) {
    const practiceBtns = document.querySelectorAll('.practice-btn');
    practiceBtns.forEach((btn, i) => {
        const eventType = isTouchScreen ? 'touchend' : 'click';
        btn.addEventListener(eventType, (e) => {
            handlePracticeButtonPress(btn, answer, practiceBtns, i, choices, onCorrect, onIncorrect);
        });
    });
}
function handlePracticeButtonPress(btn, answer, practiceBtns, responsevalue, choices, onCorrect, onIncorrect) {
    var _a;
    const index = Array.prototype.indexOf.call(practiceBtns, btn);
    const choice = choices[index];
    const isCorrectChoice = (choice === null || choice === void 0 ? void 0 : choice.toString()) === answer;
    const audioConfig = {
        restrictRepetition: {
            enabled: false,
            maxRepetitions: 2,
        },
    };
    // custom incorrect prompts by task
    const incorrectPromptKey = (0, taskStore_1.taskStore)().task === 'mental-rotation' &&
        (0, taskStore_1.taskStore)().heavyInstructions &&
        ((_a = (0, taskStore_1.taskStore)().nextStimulus) === null || _a === void 0 ? void 0 : _a.trialType) == '2D'
        ? 'mentalRotationFeedbackIncorrectDownex'
        : 'feedbackTryAgain';
    if (isCorrectChoice) {
        btn.classList.add('success-shadow');
        setTimeout(() => taskSetup_1.jsPsych.finishTrial({
            response: choice,
            incorrectPracticeResponses: (0, taskStore_1.taskStore)().incorrectPracticeResponses,
            button_response: responsevalue,
        }), onCorrect ? 3000 : 1000);
        // if there is audio playing, stop it first before playing feedback audio to prevent overlap between trials
        audioHandler_1.PageAudioHandler.stopAndDisconnectNode();
        onCorrect ? onCorrect() : audioHandler_1.PageAudioHandler.playAudio(__1.mediaAssets.audio.feedbackGoodJob, audioConfig);
    }
    else {
        btn.classList.add('error-shadow');
        // jspysch disables the buttons for some reason, so re-enable them
        setTimeout(() => enableBtns(practiceBtns), 500);
        let incorrectPracticeResponses = (0, taskStore_1.taskStore)().incorrectPracticeResponses;
        incorrectPracticeResponses.push(choice);
        (0, taskStore_1.taskStore)('incorrectPracticeResponses', incorrectPracticeResponses);
        audioHandler_1.PageAudioHandler.stopAndDisconnectNode();
        onIncorrect ? onIncorrect() : audioHandler_1.PageAudioHandler.playAudio(__1.mediaAssets.audio[incorrectPromptKey], audioConfig);
    }
}
